export const iconFontAwesomeHouseholdShower = (
	<i className="fa-solid fa-shower"></i>
);
